const company = {
    getLocaleFormat: function (state) {
        let language = state.company.COMPANY?.communications_language;
        let country = state.company.COMPANY?.country;

        return language.iso_code.toLowerCase() + '-' + country.iso_code.toUpperCase();
    },
    canOfferFinance: function (state) {
        if (state.company.COMPANY?.country.iso_code === 'gb') {
            return true;
        }
        return false;
    }
}

export default company;
